import Vue from 'vue';
import Router from 'vue-router';
import LandingPage from './landing/LandingPage';
import LoginSplitPage from '../PlicCanvas/vue/login/LoginSplitPage';
import UploaderPage from './uploader/UploaderPage';
import SubjectUploaderPage from './subject-uploader/UploaderPage';
import DigitalBookPage from './digital-book/DigitalBookPage';
import OAuthRedirect from './OAuthRedirect';
import DataDeleted from './DataDeleted';
import ContentPage from './content-pages/ContentPage';
import SignedUpPage from './content-pages/SignedUpPage';
import ResetPasswordPage from '../PlicCanvas/vue/login/ResetPasswordPage.vue';

Vue.use(Router);

export default new Router({
	mode: 'history',
	fallback: false,
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/guest',
			name: 'guest',
			component: LandingPage
		},
		{
			path: '/guest/login',
			name: 'login',
			component: LoginSplitPage,
			props: {
				emailOnly: false
			},
			alias: ['/login', '/Login.php']
		},
		{
			path: '/guest/login-split',
			name: 'login-split',
			component: LoginSplitPage,
			props: {
				emailOnly: false
			},
			alias: ['/login-split']
		},
		{
			path: '/guest/reset-password',
			name: 'reset-password',
			component: ResetPasswordPage,
			alias: ['/reset-password']
		},
		{
			path: '/guest/uploader/:id?',
			name: 'uploader',
			component: UploaderPage
		},
		{
			path: '/guest/subject-uploader/:id',
			name: 'subject-uploader',
			component: SubjectUploaderPage
		},
		{
			path: '/guest/digital-book/:id',
			name: 'digital-book',
			component: DigitalBookPage
		},
		{
			path: '/guest/oauth-redirect',
			name: 'oauth-redirect',
			component: OAuthRedirect
		},
		{
			path: '/guest/data-deleted/:id',
			name: 'data-deleted',
			component: DataDeleted
		},
		{
			path: '/guest/content-pages/complete',
			name: 'content-page-complete',
			component: SignedUpPage
		},
		{
			path: '/guest/content-pages/:id',
			name: 'content-page',
			component: ContentPage
		}
	]
})
